import { Icons } from "../../../../../../../shared/icons/icons";

export function renderAboutIcon(icon) {
  const icons = {
    person: <Icons.UserRound />,
    people: <Icons.UsersRound />,
    target: <Icons.Target />,
    chart: <Icons.BarChart />,
    badge: <Icons.Award />,
    heart: <Icons.Heart />,
  };

  return icons[icon] || <Icons.UserRound />;
}

export function LeafSmallIcon() {
  return <Icons.Leaf />;
}